module.exports = __webpack_public_path__ + "img/cards.341766b6.6c8f6bc8.png";